import { render, staticRenderFns } from "./subCategoryStatus.vue?vue&type=template&id=27cc2572&"
import script from "./subCategoryStatus.vue?vue&type=script&lang=js&"
export * from "./subCategoryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports